
export function convertPxToRem(html) {
    // console.log('html',html)
    if(html){
        const rootValue = 16; // 必须与 postcss-px2rem 的 rootValue 一致
    return html.replace(/(\d+)px/g, (match, px) => {
        return `${px / rootValue}rem`;
    });
    }else{
        return ''
    }
    
}


// WEBPACK FOOTER //
// ./src/utils/utils.js